export default "https://cdn.questicon.mathletics.com/assets/images/Face with Sweat-2e79e95642af25d192cf67d333942461.svg";